var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.modalDataSelf, function(item) {
      return _c("div", { key: item.menuCode }, [
        _c("div", { staticClass: "list-title" }, [
          _vm._v(_vm._s(item.menuName))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flexStart list-main" }, [
          _c(
            "div",
            { staticClass: "list-item" },
            _vm._l(item.subnav, function(sub) {
              return _c(
                "a-checkbox",
                {
                  key: sub.menuCode,
                  staticStyle: { margin: "0 10px 5px 0" },
                  attrs: { value: sub.menuCode, disabled: sub.modified == 0 },
                  on: {
                    change: function($event) {
                      return _vm.onChange($event, sub)
                    }
                  },
                  model: {
                    value: sub.checked,
                    callback: function($$v) {
                      _vm.$set(sub, "checked", $$v)
                    },
                    expression: "sub.checked"
                  }
                },
                [_vm._v("\n          " + _vm._s(sub.label) + "\n        ")]
              )
            }),
            1
          )
        ]),
        _vm._v(" "),
        item.menuCode == "MENU0400"
          ? _c(
              "div",
              [
                _c("issueReviewModal", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showIssueReview,
                      expression: "showIssueReview"
                    }
                  ],
                  ref: "issueReviewModal",
                  refInFor: true,
                  staticClass: "issue-review-box",
                  attrs: { roleCode: "ROLE0002" }
                })
              ],
              1
            )
          : _vm._e()
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40dbaf80", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40dbaf80","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/system/character/character-edit-modal.vue
// module id = FaCY
// module chunks = 1